import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 11V6H16L12 2L8 6H11V11H6V8L2 12L6 16V13H11V18H8L12 22L16 18H13V13H18V16L22 12L18 8V11H13Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Move"
);
